import React from 'react'
import classnames from 'classnames'

const ContentNode = ({ highlight, bigger, label, value }) => {
  const _ContentNode = classnames('content-node', {
    highlight,
    bigger
  })
  
  return (
    <div className={_ContentNode}>
      {
        label && (
          <span className='content-node_label'>
            { label }
          </span>
        )
      }
      {
        value && (
          <span className='content-node_value'>
            {value}
          </span>
        )
      }
    </div>
  )
}

export default ContentNode
